import { create } from "zustand";

export const useLoaderStore = create((set) => ({
  isLoading: false,
  setLoader: (status) => {
    set({
      isLoading: status,
    });
  },
}));
